<footer class="bg-primary py-10 text-center text-secondary text-sm">
  <div class="container mx-auto px-6">
    <p>&copy; 2024 Estate360Hub – Powered by EchobitsTech</p>
    <div class="flex flex-wrap justify-center gap-4 mt-4 text-sm sm:text-base">
      <a
        class="hover:text-accent-blue transition-colors duration-200 cursor-pointer"
      >
        Privacy Policy
      </a>

      <a
        (click)="navigateToPrivacyPolicy()"
        class="hover:text-accent-blue transition-colors duration-200 cursor-pointer"
      >
        Terms of Service
      </a>

      <a
        href="#"
        class="flex items-center gap-1 hover:text-accent-blue transition-colors duration-200"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-linkedin-icon lucide-linkedin"
        >
          <path
            d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
          />
          <rect width="4" height="12" x="2" y="9" />
          <circle cx="4" cy="4" r="2" />
        </svg>
        LinkedIn
      </a>

      <a
        href="https://x.com/Echobitstech?t=2jsBwIfas8NE0Zck1fy4Ww&s=08"
        class="flex items-center gap-1 hover:text-accent-blue transition-colors duration-200"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-twitter-icon lucide-twitter"
        >
          <path
            d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"
          />
        </svg>
        Twitter
      </a>

      <a
        href="https://www.instagram.com/reel/DKzOjWyo4of/?igsh=OTh0eGlhamlvbDd3"
        class="flex items-center gap-1 hover:text-accent-blue transition-colors duration-200"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-instagram-icon lucide-instagram"
        >
          <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
          <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
        </svg>
        Instagram
      </a>
    </div>
  </div>
</footer>
